import { render, staticRenderFns } from "./DetailGeoNovation.vue?vue&type=template&id=0c6b6b0d&"
import script from "./DetailGeoNovation.vue?vue&type=script&lang=js&"
export * from "./DetailGeoNovation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports